/* eslint-disable prefer-destructuring, no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { pickOutSounds } from '@/utils/sounds';
import { DEVICE } from '@/constants';
import { OS } from '@/utils/detectDevice';
import './style.less';

class PickOut extends React.Component {
  static propTypes = {
    finished: PropTypes.func,
    exercisesData: PropTypes.object,
    url: PropTypes.string,
    audioStop: PropTypes.func,
    audioPlay: PropTypes.func,
    soundsUrl: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      picOutData: null,
      audio: '',
      right: false,
      playing: false,
    };
  }

  componentDidMount() {
    const { exercisesData, url } = this.props;
    this.init(exercisesData, url);
  }

  componentWillReceiveProps(nextProps) {
    nextProps.url !== this.props.url && this.init(nextProps.exercisesData, nextProps.url);
  }

  init = (exercisesData, url) => {
    const xmlData = exercisesData.questions[0].question[1];
    const question = xmlData && xmlData.answer.length === 4
      ? xmlData
      : exercisesData.questions[0].question[0];
    const picOutData = question.answer.map(item => ({
      img: `${url}${item._attr.image._value}`,
      txt: item._attr.text._value,
      val: item._attr.score._value,
      class: '',
    }));
    this.setState({
      picOutData,
      audio: `${url}QAA/${question._attr.audio._value}.ogg`,
    });
  }

  handleCheck=(e, i) => {
    const { picOutData } = this.state;
    const { soundsUrl } = this.props;
    e.preventDefault();
    let right = false;
    if (!this.state.right) {
      picOutData.forEach((item, index) => {
        console.log(item);
        picOutData[index].class = '';
      });
      if (picOutData[i].val === 100) {
        right = true;
        picOutData[i].class = 'right';
        this.props.audioPlay(`${soundsUrl}${pickOutSounds.allRight}`, { type: 'exercise' });
        this.props.finished();
      } else {
        this.props.audioPlay(`${soundsUrl}${pickOutSounds.wrong}`, { type: 'exercise' });
        picOutData[i].class = 'wrong';
      }
      OS.TYPE === DEVICE.PC && this.audioEnd();
    }
    this.setState({ picOutData, right });
  }

  handlePlay = () => {
    const { playing, audio } = this.state;
    !playing ? this.props.audioPlay(audio, { type: 'exercise' }) : this.props.audioStop();
  }

  audioPlay = () => this.setState({ playing: true });

  audioEnd = () => this.setState({ playing: false });

  render() {
    const { picOutData, playing, right } = this.state;
    return (
      <div className="pick-out-container">
        <ul>
          {
            picOutData && picOutData.map((item, index) => (
              <li
                key={`li${index + 1}`}
                className={item.class}
                data-val={item.val}
                onClick={(e) => { !right && this.handleCheck(e, index); }}
              >
                <img src={item.img} alt="" />
              </li>
            ))
          }
        </ul>
        <div className={`pick-out-play${playing ? ' playing' : ''}`} onClick={this.handlePlay} />
      </div>
    );
  }
}

export default PickOut;
